<template>
  <skud-consumer-token-list />
</template>

<script>
import SkudConsumerTokenList from '@/views/skud/components/SkudConsumerTokenList.vue'

export default {
  name: 'SkudConsumerTokenListPage',
  components: { SkudConsumerTokenList }
}
</script>
